import { render } from "./Testimonial4Page.vue?vue&type=template&id=c6f5bf74&scoped=true&ts=true"
import script from "./Testimonial4Page.vue?vue&type=script&lang=ts"
export * from "./Testimonial4Page.vue?vue&type=script&lang=ts"

import "./Testimonial4Page.vue?vue&type=style&index=0&id=c6f5bf74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6f5bf74"]])

export default __exports__